require('../../modules/es.array.fill');
var entryUnbind = require('../../internals/entry-unbind');

module.exports = entryUnbind('Array', 'fill');
